import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, map, capitalize,
} from 'lodash';
import {
  normalizeAmount,
  formatData,
} from '../../../utils/transformer.util';
import {
  Button, Select, Input, SearchSelect,
} from '../../../components/base';
import { PEMBAGIAN_KELAS_PPDB_TABEL_FIELDS } from '../../../constants/kurikulum/kurikulum.constant';
import { validateRequiredFields } from '../../../utils/validation.util';

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};
export default class PembagianKlsAjaranBaru extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitPPDBOffline = this.onSubmitPPDBOffline.bind(this);
    this.onSubmitNext = this.onSubmitNext.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getPrmLevels = this._getPrmLevels.bind(this);
    this._getClassesOptions = this._getClassesOptions.bind(this);
    this._getNewStudentOptions = this._getNewStudentOptions.bind(this);
    this._getClassroomsOptions = this._getClassroomsOptions.bind(this);
    this._getStudentPPDBOptions = this._getStudentPPDBOptions.bind(this);
    this._getStudentPPDBRicciOptions = this._getStudentPPDBRicciOptions.bind(this);
    this._getStudentNextClassOptions = this._getStudentNextClassOptions.bind(this);
    this._getNewStudentPPDBOptions = this._getNewStudentPPDBOptions.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._initializeData = this._initializeData.bind(this);

    const { user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;
    this.state = {
      content: initialContent,
      listAmount: 5,
      list: [],
      filters: {},
      form: {
        value: {
          organizations_id,
          units_id: school_unit.id,
          levels_id,
          pembagian_kelas: [
            {
              students_id: '',
              period: '',
              classrooms_id: '',
              date: '',
            },
          ],
          class_div: 'ppdb',
        },
        error: {
          pembagian_kelas: '',
        },
      },
      param: {},
    };
  }

  componentDidMount() {
    const { content } = this.state;
    const { location, user } = this.props;
    const { school_unit, organizations_id } = user;
    const { levels_id } = school_unit;
    const { state = {} } = location;

    // const { isEdit = false, data } = location.state;
    const { id } = state.data || '';
    this._initializeData();
  }

  async _initializeData(savedFilters = {}) {
    const { content } = this.state;
    const { location, user } = this.props;
    const { school_unit, organizations_id } = user;
    const { levels_id, subdomain } = school_unit;
    const { state = {} } = location;

    // const { isEdit = false, data } = location.state;
    const { id } = state.data || '';

    const paramTypes = ['classes', 'levels', 'classrooms'];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });

    await this._getPeriodsOptions({ units_id: [school_unit.id] });
    this._getClassroomsOptions();
    this._getClassesOptions({
      filters: { levels_id: [levels_id], units_id: [school_unit.id] },
    });
    // this._getNewStudentOptions();
    this._getPrmLevels({
      filters: { units_id: [school_unit.id], organizations_id },
    });
    this._getStudentPPDBOptions({subdomain: subdomain});
    if (organizations_id == 4 || organizations_id == 5) {
      this._getStudentPPDBRicciOptions();
    }
    this._getStudentNextClassOptions();
    this._getNewStudentPPDBOptions();

    if (isEmpty(content.list)) {
      this._onSearchContent({ page: 1 });
    }
  }

  // componentDidUpdate(prevProps) {
  //   const { location } = this.props;
  //   const { state = {} } = location;
  //   const { id } = state.data || "";

  //   if (!id && !isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;

    if (type === 'classrooms' || type === 'classrooms') {
      filters.organizations_id = organizations_id;
      filters.levels_id = levels_id;
      filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }


  // on formchange untuk form
  _onFormChange(event) {
    const { user } = this.props;
    const { organizations_id } = user;
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { filters, form } = this.state;
    if (name == 'classes_id') {
      delete form.value.classrooms_id;
      const formValue = form.value;
      delete formValue.classrooms_id;
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: formValue,
        },
      }));
    }
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
         newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      if (name === 'levels_id') {
        this._getClassesOptions({ filters: { levels_id: [value] } });
      }
      if (name === 'classes_id' || name === 'periods_id') {
        this._getClassroomsOptions('classrooms', {
          classes_id: value,
          organizations_id,
        });
      }
      if (name === 'classrooms_id') {
        const param = this.state.param.classrooms;
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              capacity: param.find(i => i.value == value) ? param.find(i => i.value == value).attributes.capacity : '',
            },
          },
        }));
      }
      if (name == 'class_div' || name == 'classes_id') {
        delete filters.students_id;
        this.setState(prevState => ({
          ...prevState,
          filters,
        }));
      }
      if (name == 'class_div') {
        this._onSearchContent();
      }
      // if (name == "classes_id"){
      //   this._onSearchContent();
      // }
      // this._onSearchContent();
    });
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => this._onSearchContent());
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const {
      class_div, classes_id, periods_id, nextyear,
    } = value;

    const year = nextyear.substring(2);

    try {
      const {
        handleListStudentsPPDB, handleListPPDBOffline, user, handleListStudentsPPDBF07,
        handleListStudentsClassDivGeneral, handleListStudentsPPDBRicci,
      } = this.props;
      const { organizations_id, school_unit } = user;
      let result = {};

      if (organizations_id == 3 && school_unit.ppdb_online === 1 && school_unit.unit_code !== 'F07' && school_unit.subdomain == null) {
        result = await handleListStudentsPPDB({
          ...params,
          organizations_id,
          units_id: school_unit.id,
          filters,
          classrooms_id: value.classrooms_id,
        });
      } else if (school_unit.ppdb_online === 0) {
        result = await handleListPPDBOffline({
          ...params,
          organizations_id,
          units_id: school_unit.id,
          year,
          filters,
          classrooms_id: value.classrooms_id,
        });
      } else if (organizations_id == 3 && school_unit.ppdb_online == 1 && school_unit.unit_code == 'F07') {
        result = await handleListStudentsPPDBF07({
          ...params,
          year,
          organizations_id,
          units_id: school_unit.id,
          filters,
          classrooms_id: value.classrooms_id,
        });
      } else if (school_unit.ppdb_online == 1 && school_unit.unit_code !== 'F07' && school_unit.subdomain !== null) {
        result = await handleListStudentsClassDivGeneral({
          ...params,
          filters,
          year,
          subdomain: school_unit.subdomain,
        });
      } else if (organizations_id == 4 || organizations_id == 5 && school_unit.ppdb_online == 1 && school_unit.subdomain == null && school_unit.unit_code !== 'F07') {
        result = await handleListStudentsPPDBRicci({
          ...params,
          // year: year,
          type: school_unit.ppdb_name,
          organizations_id,
          units_id: school_unit.id,
          filters,
        });
      }
      const { classes = [], data = [] } = result;
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            pembagian_kelas: result,
          },
        },
      }));

      // }
    } catch (err) {
      // if (this.isMount) {
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            pembagian_kelas: [],
          },
        },
      }));
    }
    // }
  }

  async onSubmit() {
    const { history, handleSaveClassDivPPDB } = this.props;
    const { form } = this.state;
    const { value } = form;
    const error = validateRequiredFields(form.value, ['periods_id', 'classes_id', 'classrooms_id']);
    this.setState(prevState => ({
      form: {
        value: prevState.form.value,
        error,
      },
    }));
    if (isEmpty(error)) {
      await handleSaveClassDivPPDB(value);
      history.push('/dashboard/tata-usaha/manajemen-kelas/pengaturan-kelas-ajaran-baru');
    }
  }


  async onSubmitPPDBOffline() {
    const { history, handleSaveClassPPDBOffline } = this.props;
    const { form } = this.state;
    const { value } = form;
    const error = validateRequiredFields(form.value, ['periods_id', 'classes_id', 'classrooms_id']);
    this.setState(prevState => ({
      form: {
        value: prevState.form.value,
        error,
      },
    }));
    if (isEmpty(error)) {
      await handleSaveClassPPDBOffline(value);
      history.push('/dashboard/tata-usaha/manajemen-kelas/pengaturan-kelas-ajaran-baru');
    }
  }

  async onSubmitNext() {
    const { history, handleSaveNextClassDiv } = this.props;
    const { form } = this.state;
    const { value } = form;
    const error = validateRequiredFields(form.value, ['periods_id', 'classes_id', 'classrooms_id']);
    this.setState(prevState => ({
      form: {
        value: prevState.form.value,
        error,
      },
    }));
    if (isEmpty(error)) {
      await handleSaveNextClassDiv(value);
      history.push('/dashboard/tata-usaha/manajemen-kelas/pengaturan-kelas-ajaran-baru');
    }
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const res = await getPeriodsOptions(filters);
    filters.organizations_id = organizations_id;

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);

      if (date > start_date) {
        if (res[idx + 1]) {
          this.setState(prevState => ({
            ...prevState,
            filters: {
              ...prevState.filters,
              year: (res[idx + 1].label.substring(0, 4)).substring(2),
            },
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                periods_id: res[idx + 1].value,
                nextyear: res[idx + 1].label.substring(0, 4),
              },
            },
          }));
        }
      }
    });

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  async _getClassesOptions(filters = {}) {
    const { getClassesOptions, user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;
    filters.levels_id = levels_id;
    filters.units_id = school_unit.id;

    const res = await getClassesOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        classes_prm: res,
      },
    }));
  }

  async _getNewStudentOptions(filters = {}) {
    const { getNewStudentOptions } = this.props;
    const res = await getNewStudentOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student: res,
      },
    }));
  }

  async _getStudentPPDBOptions(filters = {}) {
    const { getStudentPPDBOptions } = this.props;
    const res = await getStudentPPDBOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student_ppdb: res,
      },
    }));
  }

  async _getStudentPPDBRicciOptions(filters = {}) {
    const { getStudentPPDBRicciOptions } = this.props;
    const res = await getStudentPPDBRicciOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student_ppdb: res,
      },
    }));
  }

  async _getStudentNextClassOptions() {
    const { filters, form } = this.state;
    const { getStudentNextClassOptions, user } = this.props;
    const { organizations_id, school_unit } = user;

    // filters.period=form.value.periods_id
    const res = await getStudentNextClassOptions({
      filters,
      units_id: school_unit.id,
      organizations_id,
    });
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student_next: res,
      },
    }));
  }

  async _getNewStudentPPDBOptions() {
    const { filters, form } = this.state;
    const {
      getNewStudentPPDBOptions, user, getStudentPPDBOptions,
      getStudentPPDBF07Options, getStudentPPDBRicciOptions,
    } = this.props;
    const { organizations_id, school_unit } = user;
    const { value } = form;
    const { nextyear } = value;

    const year = nextyear.substring(2);

    // filters.period=form.value.periods_id
    let res = {};
    if (school_unit.ppdb_online == 0) {
      res = await getNewStudentPPDBOptions({
        filters,
        units_id: school_unit.id,
        organizations_id,
        year,
      });
    } else if (school_unit.ppdb_online == 1 && school_unit.unit_code !== 'F07' && school_unit.subdomain == null && organizations_id == 3) {
      res = await getStudentPPDBOptions({
        filters,
      });
    } else if (school_unit.ppdb_online == 1 && school_unit.unit_code == 'F07') {
      res = await getStudentPPDBF07Options({
        filters: { year },
      });
    } else if (school_unit.ppdb_online == 1 && school_unit.unit_code !== 'F07' && school_unit.subdomain == null && organizations_id == 4 || organizations_id == 5) {
      res = await getStudentPPDBRicciOptions({
        filters,
      });
    }

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student_new_ppdb: res,
      },
    }));
  }

  async _getClassroomsOptions() {
    const { getClassroomsOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { form } = this.state;
    const {
      classes_id, levels_id, periods_id, classrooms_id,
    } = form.value;

    const res = await getClassroomsOptions({
      classes_id,
      levels_id,
      periods_id,
      units_id: school_unit.id,
    });

    const selectedClassroom = res.find(item => item.value == classrooms_id);

    // console.log(selectedClassroom, res, classrooms_id);
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          capacity: selectedClassroom
            ? selectedClassroom.attributes.capacity
            : '',
        },
      },
      param: {
        ...prevState.param,
        classrooms: res,
      },
    }));
  }

  render() {
    const {
      param,
      form,
      list = {},
      filters,
    } = this.state;
    const { pembagian_kelas } = form.value;
    const { students_id = '' } = filters;
    const { user } = this.props;
    const { school_unit } = user;
    const class_div = [{ label: 'Pembagian Kelas Siswa PPDB', value: 'ppdb' },
      { label: 'Pembagian Kelas Siswa Kenaikan Kelas', value: 'next_class' }];


      console.log(form.value.class_div)
    return (
      <div className="absensi-rekap__custom-form">
        <div className="absensi-rekap__custom-form-row">
          <div className="absensi-rekap__custom-form-row__field">
            <Select
              name="periods_id"
              label="Tahun Ajaran"
              placeholder="Pilihan"
              onChange={this._onFormChange}
              data={param.periods}
              value={form.value.periods_id}
              error={form.error.periods_id || ''}
              disabled
            />
          </div>
          <div className="absensi-rekap__custom-form-row__field">
            <Select
              name="class_div"
              label="Pilih Pembagian Kelas"
              onChange={this._onFormChange}
              data={class_div}
              placeholder="Pilihan"
              value={form.value.class_div}
              error={form.error.class_div || ''}
              disabled
            />
          </div>
        </div>

        {form.value.class_div && (
          <>
            <div className="absensi-rekap__custom-form-row">
              <div className="absensi-rekap__custom-form-row__field">
                <Select
                  placeholder="Pilih Tingkat Kelas"
                  label="Tingkat Kelas"
                  name="classes_id"
                  value={form.value.classes_id}
                  error={form.error.classes_id}
                  data={param.classes_prm}
                  onChange={this._onFormChange}
                />
              </div>
              <div className="absensi-rekap__custom-form-row__field">
                <Select
                  placeholder="Pilih Kelas"
                  label="Kelas"
                  name="classrooms_id"
                  value={form.value.classrooms_id}
                  error={form.error.classrooms_id}
                  data={param.classrooms}
                  onChange={this._onFormChange}
                  disabled={!form.value.classes_id}
                  isRequired
                />
              </div>
            </div>

            <div className="absensi-rekap__custom-form-row">
              <div className="absensi-rekap__custom-form-row__field">
                <SearchSelect
                  noMargin
                  async={false}
                  name="students_id"
                  list={form.value.class_div == 'ppdb' ? param.student_ppdb : param.student_next}
                  inputArray
                  onClick={this._onChangeFilter}
                  placeholder="Pilih Nama Siswa"
                  value={filters.students_id}
                  rightIcon="icon-search"
                  label="Nama Siswa"
                />
              </div>
              <div className="absensi-rekap__custom-form-row__field">
                <Input
                  label="Daya Tampung"
                  name="capacity"
                  value={form.value.capacity}
                  data={param.classrooms}
                  onChange={this._onFormChange}
                  disabled
                />
              </div>
            </div>
          </>
        )}
        <div />

        <div className="fund-request__content">
          <table className="table">
            <thead>
              <tr>
                {map(PEMBAGIAN_KELAS_PPDB_TABEL_FIELDS.label, (field, idx) => (
                  <th key={`table_th_${idx}`}>{field}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* {pembagian_kelas.no_va? */}
              {map(pembagian_kelas, (data, idx) => (
                <tr key={`budget_row_${idx}`}>
                  {map(PEMBAGIAN_KELAS_PPDB_TABEL_FIELDS.value,
                    (field, fieldIdx) => {
                      if (fieldIdx === 0) {
                        return (
                          <td key={`table_index_${fieldIdx}_${idx}`} style={{ textAlign: 'center' }}>
                            {idx + 1}
                          </td>
                        );
                      }
                      if (field.attribute === 'checkbox') {
                        return (
                          <td key={`table_${fieldIdx}_${idx}`} style={{ textAlign: 'center' }}>
                            <Input
                              type="checkbox"
                              name="checkbox"
                              data-input-array
                              data-array-position={idx}
                              data-field-name="pembagian_kelas"
                              onChange={this._onFormChange}
                                  // checked={list.checkbox}
                              checked={data.checkbox == true}
                              value={data.checkbox ? data.checkbox : false}
                            />{' '}
                          </td>
                        );
                      }
                      if (field.attribute === 'nisn') {
                        return (
                          <td key={`table_${fieldIdx}_${idx}`} style={{ textAlign: 'center' }}>
                            {capitalize(data.nisn ? data.nisn : '')}
                          </td>
                        );
                      }
                      if (field.attribute === 'no_va') {
                        return (
                          <td key={`table_${fieldIdx}_${idx}`} style={{ textAlign: 'center' }}>
                            {capitalize(data.no_va ? data.no_va : '')}
                          </td>
                        );
                      }
                      if (field.attribute === 'fullname') {
                        return (
                          <td key={`table_${fieldIdx}_${idx}`} style={{ textTransform: 'capitalize' }}>
                            {capitalize(data.fullname ? data.fullname : '')}
                          </td>
                        );
                      }

                      return (
                        <td
                          className={field.type === 'number' ? 'nominal' : ''}
                          key={`table_${fieldIdx}_${idx}`}
                        >
                          {formatData(data, field)}
                        </td>
                      );
                    })}
                </tr>
              ))}
              {/* // :
                  // <td colSpan={5}>Data PPDB Offline Belum Ada</td>} */}
            </tbody>
          </table>
        </div>
        {school_unit.ppdb_online == 1
          ? (
            <div className="student-list__button">
              <Button type="button" title="Simpan" onClick={this.onSubmit} />
            </div>
          )
          : (
            <div className="student-list__button">
              <Button type="button" title="Simpan PPDB Offline" onClick={this.onSubmitPPDBOffline} />
            </div>
          )
          }


      </div>
    );
  }
}
PembagianKlsAjaranBaru.propTypes = {
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
};
PembagianKlsAjaranBaru.defaultProps = {
  user: null,
};
